import { MessageSquare, Plus, Trash2 } from 'lucide-react';
import { cx } from '@/lib/cx';
import { formatRelative } from '@/lib/format';
import { t } from '@/lib/i18n';
import { Button, EmptyState, ErrorState, IconButton, LoadingState } from '@/ui';
import { useDeleteThread, useThreads } from './api';
import s from './Assistant.module.css';
import { setThread } from './store';

export function ThreadList({ current }: { current: string | null }) {
  const threads = useThreads(true);
  const remove = useDeleteThread();
  if (threads.isPending) return <LoadingState />;
  if (threads.error) return <ErrorState error={threads.error} onRetry={() => void threads.refetch()} compact />;
  return (
    <div className={s.threads}>
      <Button icon={Plus} block onClick={() => setThread(null)}>
        {t('New conversation')}
      </Button>
      {threads.data.length === 0 ? (
        <EmptyState compact icon={MessageSquare} title={t('No conversations yet')} />
      ) : (
        <ul className={s.threadList}>
          {threads.data.map((th) => (
            <li key={th.id} className={cx(s.thread, th.id === current && s.threadActive)}>
              <button type="button" className={s.threadButton} onClick={() => setThread(th.id)}>
                <span className={s.threadTitle}>{th.title}</span>
                <span className={s.threadMeta}>{formatRelative(String(th.updated_at))}</span>
              </button>
              <IconButton
                icon={Trash2}
                size="sm"
                label={t('Delete conversation')}
                onClick={() => remove.mutate(th.id, { onSuccess: () => th.id === current && setThread(null) })}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
